import taskKanban from "@/pages/task/taskKanban.vue";
import taskAdd from "@/pages/task/taskAdd.vue";
import taskEdit from "@/pages/task/taskEdit.vue";
import taskList from "@/pages/task/taskList.vue";
import taskDetail from "@/pages/task/taskDetail.vue";
import taskSummary from "@/pages/task/taskSummary.vue";

import {PathName} from "@/constant/routeData";

export default [
  {
    path: '/kanban',
    name: PathName.TaskKanban,
    component: taskKanban,
  },
  {
    path: '/taskAdd',
    name: PathName.TaskAdd,
    component: taskAdd,
  },
  {
    path: '/taskSummary',
    name: PathName.TaskSummary,
    component: taskSummary,
  },
  {
    path:'/taskEdit/:task_no?',
    name: PathName.TaskEdit,
    component: taskEdit
  },
  {
    path:'/taskDetail/:task_no?',
    name: PathName.TaskDetail,
    component: taskDetail
  },
  {
    path:'/taskList',
    name: PathName.TaskList,
    component: taskList
  }
]
